import React from 'react';
import styles from './Modal.module.scss';
import cn from "classnames";
import { useCommunity } from "../../context/community";

const ModalHeader = ({ title, description, className }) => {
    const {community: { domain }} = useCommunity();
    return (
        <div className={cn(styles.modalHeader, className)}>
            <h2 className={domain === 'nw' ? styles.renTitle : null}>{title}</h2>
            <p>{description}</p>
        </div>
    );
};

export default ModalHeader;